export const PAGE_VIEW_THRESHOLD = 2;

export const AUTO_SHOWN_KEY = 'identification_sign_up_auto_shown';
